import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsOptional } from 'class-validator';


export class EmployeeWeekOffUploadsDTO {
    @ApiProperty()
    @IsNotEmpty()
    weekOffId: number;


    @ApiProperty()
    @IsOptional()
    employeeId: number;

    @ApiProperty()
    @IsNotEmpty()
    employeeCode: string;

    @ApiProperty()
    @IsNotEmpty()
    EmployeeType: string;

    @ApiProperty()
    @IsNotEmpty()
    employeeCategory: string;

    @ApiProperty()
    @IsNotEmpty()
    weekOffDay: string;


    @ApiProperty()
    @IsNotEmpty()
    createdUser: string;


    @ApiProperty()
    @IsOptional()
    createdAt: Date;


    @ApiProperty()
    updatedAt: Date;

    
    @ApiProperty()
    @IsNotEmpty()
    updatedUser: string;
}
